import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { EntityActionPopupComponent } from './components/entity-action-popup/entity-action-popup.component';
import { EntityListComponent } from './components/entity-list/entity-list.component';
import { EntityAdapter } from './entity.adapter';
import {
	EntityEffects,
	EntityFeatureKey,
	entityReducers,
	EntitySelector,
} from './store';

@NgModule({
	declarations: [EntityListComponent, EntityActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(EntityFeatureKey, entityReducers),
		EffectsModule.forFeature([EntityEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcAvatarModule,
		DcBreadcrumbModule,
		DcButtonModule,
	],
	providers: [EntityAdapter, EntitySelector],
})
export class EntityModule {
	public constructor(private readonly injector: Injector) {
		const entityListCmpElement = createCustomElement(EntityListComponent, {
			injector,
		});
		customElements.define('app-entity-list', entityListCmpElement);
	}
}
